// services/projectServices.ts

import axiosInstance from "../api/authAPI";
import {
  FetchProjectParams,
  ProjectCreateResponse,
  ProjectDetailsResponse,
  ProjectListResponse,
} from "../types/project";
interface ProjectDropDown {
  id: number; // use `key` from API as `id` here
  name: string;
}
// Create a new project
export const createProjectAPI = async (
  formData: FormData
): Promise<ProjectCreateResponse> => {
  try {
    const response = await axiosInstance.post("/projects", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Project creation failed";
  }
};

// Fetch paginated project list
export const fetchProjectList = async (
  params: FetchProjectParams
): Promise<ProjectListResponse> => {
  try {
    const response = await axiosInstance.get<ProjectListResponse>("/projects", {
      params,
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to fetch project list";
  }
};

// delete Project
export const deleteProject = async (
  id: number
): Promise<ProjectListResponse> => {
  try {
    const response = await axiosInstance.delete(`/projects/${id}`);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Project deletion failed" };
  }
};

// update project
export const updateProject = async (
  id: number,
  userData: FormData
): Promise<ProjectCreateResponse> => {
  try {
    const response = await axiosInstance.post<ProjectCreateResponse>(
      `/projects/${id}`,
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Project update failed";
  }
};

// project dropdown list
export const fetchProjectDropdownList = async (): Promise<
  ProjectDropDown[]
> => {
  const response = await axiosInstance.get("/projects-list");
  const data = response.data;

  if (data.status) {
    // Convert `key` to `id` so your dropdown uses `project.id`
    return data.data.map((project: any) => ({
      id: project.key,
      name: project.name,
      start: project.start,
      end: project.end,
    }));
  } else {
    throw new Error(data.message || "Failed to fetch project list");
  }
};

// project detail by id
export const detailProject = async (
  id: number
): Promise<ProjectDetailsResponse> => {
  try {
    const response = await axiosInstance.get(`/projects/${id}`);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Project deletion failed" };
  }
};
